<template>
  <div>
    <h3 style="text-align: center">入库管理</h3>
    <el-card style="width: 1400px; margin: 30px auto 0">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input
            v-model="drugNameOrCode"
            placeholder="请输入药品名称"
            size="medium"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="factoryNameOrCode"
            placeholder="请输入产地名称"
            size="medium"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="spec"
            placeholder="请输入药品规格"
            size="medium"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model="supplierNameOrCode"
            placeholder="请输入代理商名称"
            size="medium"
          ></el-input>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" size="medium" @click="getQueryordercheck"
            >查询</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="tableQueryorder"
        style="width: 100%; margin-top: 20px"
        border
        v-loading="loading"
      >
        <el-table-column prop="num" label="订单号" width="120px" align="center">
        </el-table-column>
        <el-table-column
          prop="drugNum"
          label="药品编号"
          width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="drugName"
          label="药品名称"
          width="120px"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="factroy"
          label="厂家"
          width="180px"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="specification"
          label="规格"
          width="110px"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column
            prop="prodAddress"
            label="产地">
         </el-table-column> -->
        <el-table-column prop="pack" label="包装" width="60px" align="center">
        </el-table-column>
        <el-table-column
          prop="drugType"
          label="剂型"
          width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="drugUnit"
          label="单位"
          width="60px"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="counts" label="数量" width="70px" align="center">
        </el-table-column>
        <el-table-column
          prop="purchPrice"
          label="进价"
          width="60px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="wholePrice"
          label="批量价"
          width="70px"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column prop="batchNum" label="批号"> </el-table-column>  -->
        <el-table-column
          prop="supplierName"
          label="供应商名称"
          width="180px"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="approvalNum"
          label="批准文号"
          width="140px"
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          width="85px"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.createDate.split("T")[0] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="drugOwner"
          label="上市许可持有人"
          width="120px"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          width="340px"
        >
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              @click="handleCheck(scope.row)"
              >查看</el-button
            >
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              type="warning"
              size="mini"
              @click="handleUpload(scope.row)"
              >上传证件</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="handleSq(scope.row)"
              >欠票申请</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 上传证件 -->
    <el-dialog
      title="上传证件"
      :visible.sync="dialogUpload"
      :width="'800px'"
      center
      :close-on-click-modal="false"
    >
      <el-form :model="formUpload" label-width="120px">
        <el-form-item label="上传图片：" class="is-required">
          <el-upload
            action=""
            list-type="picture-card"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="uploadFile"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="证件类型：" class="is-required">
          <el-select v-model="formUpload.CertName" placeholder="请选择证件类型">
            <el-option label="合同" value="合同"></el-option>
            <el-option label="质检单" value="质检单"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="formUpload.CertName == '合同' ? '合同号：' : '批号：'"
          class="is-required"
        >
          <el-input v-model="formUpload.CertNo"></el-input>
        </el-form-item>
        <el-form-item label="证件起始日期：">
          <el-date-picker
            v-model="formUpload.StartDueDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="证件截止日期：">
          <el-date-picker
            v-model="formUpload.EndDueDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="formUpload.Remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogUpload = false">取 消</el-button>
        <el-button type="primary" @click="submitUp">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改订单 -->
    <el-dialog
      title="修改订单"
      :visible.sync="dialogEditOrder"
      :width="'600px'"
      center
      :close-on-click-modal="false"
    >
      <el-form :model="formEditOrder" label-width="110px">
        <el-form-item label="发票号：" class="is-required">
          <el-input v-model="formEditOrder.invoiceNo"></el-input>
        </el-form-item>
        <el-form-item label="进价：" class="is-required">
          <el-input v-model="formEditOrder.purchPrice"></el-input>
        </el-form-item>
        <el-form-item label="批量价：" class="is-required">
          <el-input v-model="formEditOrder.tradePrice"></el-input>
        </el-form-item>
        <el-form-item label="数量：" class="is-required">
          <el-input v-model="formEditOrder.goodsNum"></el-input>
        </el-form-item>
        <el-form-item label="发票时间：" class="is-required">
          <el-date-picker
            v-model="formEditOrder.invoiceDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            :picker-options="pickerOptionsOrder"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="随货同行单：" class="is-required">
          <el-date-picker
            v-model="formEditOrder.goodsBillDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            :picker-options="pickerOptionsOrder"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="formEditOrder.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogEditOrder = false">取 消</el-button>
        <el-button type="primary" @click="submitEditOrder">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog
      title="入库申请详情"
      :visible.sync="dialogDetail"
      :width="'1100px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-table :data="dataDetails" style="width: 100%" border>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="证件图片：">
                  <img
                    style="
                      width: 120px;
                      border: 1px solid #ddd;
                      margin-left: 15px;
                    "
                    v-for="(item, index) in scope.row.images"
                    :key="index"
                    :src="item"
                    alt=""
                  />
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            prop="bussinessNo"
            label="订单号"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="certType"
            label="证件类型"
            align="center"
            width="90px"
          >
          </el-table-column>
          <el-table-column
            prop="certName"
            label="证件名"
            align="center"
            width="90px"
          >
          </el-table-column>
          <el-table-column prop="certNo" label="证件号" header-align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注" header-align="center">
          </el-table-column>
          <el-table-column
            prop="updateDate"
            label="时间"
            align="center"
            width="130px"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.updateDate.split(".")[0].replace("T", " ") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="90px">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drugNameOrCode: "",
      factoryNameOrCode: "",
      spec: "",
      supplierNameOrCode: "",
      tableQueryorder: [],
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      dialogUpload: false,
      formUpload: {
        ID: "",
        FileDatas: [],
        BussinessID: "",
        BussinessNo: "",
        CertType: "采购入库",
        CertName: "",
        CertNo: "",
        StartDueDate: "",
        EndDueDate: "",
        Remark: "",
        TagA: "",
        TagB: "",
        TagC: "",
        TagD: "",
        ClerkNum: "",
      },
      fileList: [],
      initUploadForm: {},
      param: new FormData(),
      Stime: "", //限制开始时间要大于创建日期
      dialogEditOrder: false,
      formEditOrder: {
        id: "",
        invoiceNo: "",
        invoiceDate: "",
        goodsBillDate: "",
        remark: "",
        purchPrice: 0,
        tradePrice: 0,
        goodsNum: 0,
      },
      initEditOrderForm: {},
      dialogDetail: false,
      dataDetails: [], //订单详情列表
      bussinessID: "",
      loading: true,
    };
  },
  computed: {
    //  pickerOptions() {
    //    let _this = this;
    //    return {
    //      disabledDate(time) {
    //        return time.getTime() < _this.Stime;
    //      },
    //    };
    //  },
    pickerOptionsOrder() {
      let _this = this;
      return {
        disabledDate(time) {
          return time.getTime() < _this.Stime || time.getTime() > Date.now();
        },
      };
    },
  },

  components: {},

  created() {
    this.initUploadForm = { ...this.formUpload };
    this.initEditOrderForm = { ...this.formEditOrder };
    this.getQueryordercheck();
    // this.getGuid();
  },
  methods: {
    dateFormat(Date, fmt) {
      var o = {
        "M+": Date.getMonth() + 1, //月份
        "d+": Date.getDate(), //日
        "H+": Date.getHours(), //小时
        "m+": Date.getMinutes(), //分
        "s+": Date.getSeconds(), //秒
        "q+": Math.floor((Date.getMonth() + 3) / 3), //季度
        S: Date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (Date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    //  查询入库订单
    getQueryordercheck() {
      this.pageIndex = 1;
      this.searchQueryordercheck();
    },
    //获取入库订单
    searchQueryordercheck() {
      this.loading=true;
      this.$http
        .post("Dls/getFun", {
          action: "Queryordercheck",
          obj: JSON.stringify({
            drugNameOrCode: this.drugNameOrCode,
            factoryNameOrCode: this.factoryNameOrCode,
            spec: this.spec,
            supplierNameOrCode: this.supplierNameOrCode,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
          }),
        })
        .then((res) => {
          if (res.data.isok) {
            //
            this.tableQueryorder = res.data.data.rows;
            this.total = res.data.data.record;
            this.loading=false;
          }
        });
    },
    //点击上传证件
    handleUpload(rows) {
      this.formUpload = { ...this.initUploadForm };
      this.param = new FormData();
      this.fileList = [];
      this.formUpload.BussinessID = rows.id;
      this.formUpload.BussinessNo = rows.num;
      this.formUpload.StartDueDate = this.dateFormat(new Date(), "yyyy-MM-dd");
      this.formUpload.EndDueDate = this.dateFormat(new Date(), "yyyy-MM-dd");
      this.dialogUpload = true;
    },
    // 限制上传类型和大小
    beforeAvatarUpload(file) {
        let types = ['image/jpeg', 'image/jpg', 'image/png'];
        const isImage = types.includes(file.type);
        // const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isImage) {
          this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 1MB!');
        }
        return isImage && isLt2M;
      },
    //移除图片给提示
    handleRemove(file, flieList) {
      const isLt2M = file.size / 1024 / 1024 > 1;
      if(!isLt2M){
        this.$message.error("图片已移除，请重新上传！");
        this.param.delete("FileDatas");
        for (var i = 0; i < flieList.length; i++) {
          this.param.append("FileDatas", flieList[i].raw);
        }
      }   
    },
    //上传图片
    uploadFile(params) {
      const file = params.file;
      this.param.append("FileDatas", file);
    },
    //上传证件提交按钮
    async submitUp() {
      this.getGuid().then((res) => {
        this.formUpload.ID = res;
        if (this.formUpload.CertName == "") {
          this.$message.warning("对不起，您还未选择证件类型！");
        } else if (this.formUpload.CertNo == "") {
          if (this.formUpload.CertName == "合同") {
            this.$message.warning("合同号不能为空！");
          } else {
            this.$message.warning("批号不能为空！");
          }
        } else {
          let param = this.param;
          if (this.param.getAll("username") == "") {
            param.append("username", window.sessionStorage.getItem("username"));
            param.append("tokenid", window.sessionStorage.getItem("tokenid"));
            param.append(
              "phone_uuid",
              window.sessionStorage.getItem("phone_uuid")
            );
            param.append("ID", this.formUpload.ID);
            param.append("BussinessID", this.formUpload.BussinessID);
            param.append("BussinessNo", this.formUpload.BussinessNo);
            param.append("CertType", this.formUpload.CertType);
            param.append("CertName", this.formUpload.CertName);
            param.append("CertNo", this.formUpload.CertNo);
            param.append("StartDueDate", this.formUpload.StartDueDate);
            param.append("EndDueDate", this.formUpload.EndDueDate);
            param.append("Remark", this.formUpload.Remark);
            param.append("TagA", this.formUpload.TagA);
            param.append("TagB", this.formUpload.TagB);
            param.append("TagC", this.formUpload.TagC);
            param.append("TagD", this.formUpload.TagD);
            param.append("ClerkNum", this.formUpload.ClerkNum);
            this.$http
              .post("Dls/Uploadcert", param, {
                headers: {
                  "Content-Type":
                    "multipart/form-data;boundary =" + new Date().getTime(),
                },
              })
              .then((res) => {
                param.delete("FileDatas");
                if (res.data.isok) {
                  this.$message.success("操作成功！");
                  this.dialogUpload = false;
                } else {
                  this.$message.error(res.data.message);
                }
              });
          } else {
            this.$http
              .post("Dls/Uploadcert", param, {
                headers: {
                  "Content-Type":
                    "multipart/form-data;boundary =" + new Date().getTime(),
                },
              })
              .then((res) => {
                param.delete("FileDatas");
                if (res.data.isok) {
                  this.$message.success("操作成功！");
                  this.dialogUpload = false;
                } else {
                  this.$message.error(res.data.message);
                }
              });
          }
        }
      });
      //
    },
    //修改订单
    handleEdit(rows) {
      this.formEditOrder = { ...this.initEditOrderForm };
      this.formEditOrder.id = rows.id;
      this.formEditOrder.purchPrice = rows.purchPrice;
      this.formEditOrder.tradePrice = rows.wholePrice;
      this.formEditOrder.goodsNum = rows.counts;
      this.formEditOrder.invoiceNo = rows.invoiceNo;
      this.formEditOrder.remark = rows.remark;
      if (rows.invoiceDate.split("T")[0] != "0001-01-01") {
        this.formEditOrder.invoiceDate = rows.invoiceDate;
      }
      if (rows.goodsBillDate.split("T")[0] != "0001-01-01") {
        this.formEditOrder.goodsBillDate = rows.goodsBillDate;
      }
      let a = 24 * 3600 * 1000;
      this.Stime =
        new Date(rows.createDate.split("T").join(" ").split(".")[0]).getTime() -
        a;
      this.dialogEditOrder = true;
    },
    //修改订单提交按钮
    submitEditOrder() {
      this.$http
        .post("Dls/getFun", {
          action: "Modifyordercheck",
          obj: JSON.stringify(this.formEditOrder),
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success("操作成功！");
            this.searchQueryordercheck();
            this.dialogEditOrder = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //查看详情
    handleCheck(rows) {
      this.bussinessID = rows.id;
      this.getOrderDetail(this.bussinessID);
    },
    //  获取入库申请详情
    getOrderDetail(id) {
      this.$http
        .post("Dls/getFun", {
          action: "QueryordercheckDetail",
          obj: JSON.stringify({
            bussinessID: id,
          }),
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataDetails = res.data.data.rows;
            this.dialogDetail = true;
            this.dataDetails.forEach((item) => {
              item.images = [];
              for (let i = 0; i < item.urls.length; i++) {
                this.getImg(item.urls[i]).then((res) => {
                  item.images.push(res);
                });
              }
            });
          }
        });
    },
    // 获取图片
    getImg(rows) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(
            "Dls/Getinstorecert",
            {
              url: rows,
            },
            { responseType: "arraybuffer" }
          )
          .then((res) => {
            let data =
              "data:image/png;base64," +
              btoa(
                new Uint8Array(res.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 欠票申请
    handleSq(rows){
      this.$http.post('Dls/getFun',{
        action: "ClerkOweInvoiceApply",
         obj: JSON.stringify({
            ID: rows.id,
            ClerkNum:'',
            Num:rows.num,
            SupplierNum:rows.supplierNum
          }),
      }).then(res=>{
        if(res.data.data.isok){
          this.$message.success("操作成功！");
          this.searchQueryordercheck();
        }else{
          this.$message.error(res.data.data.msg);
        }
      })
    },
    //删除证件
    handleDelete(rows) {
      this.$confirm("此操作将会永久删除该证件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("Dls/getFun", {
              action: "Deleteordercheckdetail",
              obj: JSON.stringify({
                certID: rows.id,
              }),
            })
            .then((res) => {
              if (res.data.isok) {
                this.$message.success("操作成功！");
                this.getOrderDetail(this.bussinessID);
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //  获取Guid
    getGuid() {
      return new Promise((resole, reject) => {
        this.$http.get("Dls/GetGuid").then((res) => {
          resole(res.data);
        }).then((err)=>{
          reject(err)
        });
      });
    },
    // 当size发生改变时
    SizeChange(val) {
      this.pageSize = val;
      this.searchQueryordercheck();
    },
    // 当index发生改变时
    CurrentChange(val) {
      this.pageIndex = val;
      this.searchQueryordercheck();
    },
  },
};
</script>
<style lang='less' scoped>
/deep/ .el-table th {
  background-color: #eef1f6;
}
/deep/ tr td {
  font-size: 12px;
}
/deep/ .el-pagination {
  text-align: center;
  margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/pages/WarehousingManage.vue